class EqualizeTables {
  setEventHandler() {
    ['load', 'resize'].forEach((event) => {
      window.addEventListener(event, this.run);
    });

    GlobalEvents.listen('equalizeTables', this.run);

    document.addEventListener('ready', this.run);
  }

  run() {
    const dataGroups = [];

    [...document.querySelectorAll('table.io-eq-table')].filter((el) => !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length)).forEach((eqTable) => {
      if (eqTable.dataset.hasOwnProperty('eqGroup') && !dataGroups.hasOwnProperty(eqTable.dataset.eqGroup)) {
        dataGroups.push(eqTable.dataset.eqGroup);
      }
    });

    dataGroups.forEach((group) => {
      const tableArr = [...document.querySelectorAll('table')].filter((table) => table.dataset.hasOwnProperty('eqGroup') && table.dataset.eqGroup === group);
      const cellWidths = [];

      tableArr.forEach((eqTable) => {
        for (let j = 0; j < eqTable.rows[0].cells.length - 1; j++) {
          eqTable.rows[0].cells[j].style.minWidth = null;
          eqTable.rows[0].cells[j].style.width = null;
        }
      });

      tableArr.forEach((eqTable) => {
        for (let j = 0; j < eqTable.rows[0].cells.length - 1; j++) {
          const cell = eqTable.rows[0].cells[j];
          const width = parseInt(window.getComputedStyle(cell, null).getPropertyValue('width'));

          if (!cellWidths[j] || cellWidths[j] < width) cellWidths[j] = width;
        }
      });

      tableArr.forEach((eqTable) => {
        for (let j = 0; j < eqTable.rows[0].cells.length - 1; j++) {
          eqTable.rows[0].cells[j].style.width = `${cellWidths[j]}px`;
          eqTable.rows[0].cells[j].style.minWidth = `${cellWidths[j]}px`;
        }
      });
    });
  }
}

export default EqualizeTables;
